<qtm-header>
  <qtm-header-brand classes="header-logo">
    <img src="assets/{{questLogo}}" alt="cyberquest logo" />
  </qtm-header-brand>
  <qtm-header-divider classes="hidden medium:block"></qtm-header-divider>
  <qtm-header-menu classes="overflow-x-clip">
    <qtm-header-menu-left
      classes="myNavbar"
      [ngClass]="
        menuIsVisible || langIsVisible
          ? langIsVisible
            ? 'lang'
            : ''
          : 'disappear'
      "
    >
      <qtm-tabs divider="false" fullHeight>
        @if (!langIsVisible) {
          <qtm-tab
            classes="flex-shrink-0 link"
            (click)="closeMenu()"
            routerLink="/"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            {{ "header.welcome" | translate }}
          </qtm-tab>
          <qtm-tab
            classes="flex-shrink-0 link"
            (click)="closeMenu()"
            routerLink="/ctf"
            routerLinkActive="active"
            >{{ "header.ctf" | translate }}</qtm-tab
          >
          @if (isMenuItemVisible(MenuItemEnum.TOOLS)) {
            <qtm-tab
              classes="flex-shrink-0 link"
              (click)="closeMenu()"
              routerLink="/tool"
              routerLinkActive="active"
              >{{ "header.utils" | translate }}</qtm-tab
            >
          }
          @if (isMenuItemVisible(MenuItemEnum.NEWS)) {
            <qtm-tab
              classes="flex-shrink-0 link"
              (click)="closeMenu()"
              routerLink="/actualite"
              routerLinkActive="active"
              >{{ "header.news" | translate }}</qtm-tab
            >
          }
          @if (isMenuItemVisible(MenuItemEnum.CONTACT)) {
            <qtm-tab
              classes="flex-shrink-0 link"
              (click)="closeMenu()"
              routerLink="/contact"
              routerLinkActive="active"
              >{{ "header.contact" | translate }}</qtm-tab
            >
          }
          @if (isMenuItemVisible(MenuItemEnum.SCORE)) {
            <qtm-tab
              classes="flex-shrink-0 link"
              (click)="closeMenu()"
              routerLink="/hallOfFame"
              routerLinkActive="active"
              >{{ "header.scores" | translate }}</qtm-tab
            >
          }
          <qtm-tab
            *ngIf="(user$ | async)?.userRights?.writeCtf"
            classes="flex-shrink-0 link"
            (click)="closeMenu()"
            routerLink="/admin"
            routerLinkActive="active"
            >{{ "header.admin" | translate }}</qtm-tab
          >
          <qtm-tab
            classes="flex-shrink-0 link phone-only"
            (click)="closeMenu()"
            routerLink="/userProfile"
            routerLinkActive="active"
            >{{ "header.profile" | translate }}</qtm-tab
          >
          <qtm-tab classes="flex-shrink-0 link phone-only" (click)="logout()"
            >Déconnexion</qtm-tab
          >
        } @else {
            @if (isLangVisible(LangEnum.FR)) {
                <qtm-tab
                        classes="flex-shrink-0 link phone-only"
                        (click)="setLanguage('fr')"
                >FR - Français
                </qtm-tab
                >
            }
            @if (isLangVisible(LangEnum.EN)) {
                <qtm-tab
                        classes="flex-shrink-0 link phone-only"
                        (click)="setLanguage('en')"
                >ENG - English
                </qtm-tab
                >
            }
            @if (isLangVisible(LangEnum.RO)) {
                <qtm-tab
                        classes="flex-shrink-0 link phone-only"
                        (click)="setLanguage('ro')"
                >RO - Română
                </qtm-tab
                >
            }
        }
      </qtm-tabs>
    </qtm-header-menu-left>
    <qtm-header-menu-right classes="windows-only">
      <qtm-dropdown
        placement="bottom-center"
        id="qtm-dropdown"
        [visible]="langDropdownIsToggled"
        (visibleChange)="toggleLangDropdown($event)"
      >
        <qtm-dropdown-trigger>
          <qtm-button variant="ghost" color="neutral" classes="ml-s">
            <qtm-icon icon="translate"></qtm-icon>
          </qtm-button>
        </qtm-dropdown-trigger>
        <qtm-dropdown-overlay>
          <qtm-menu-item-list>
              @if (isLangVisible(LangEnum.FR)) {
                  <qtm-menu-item
                          (click)="setLanguage('fr')"
                          (keydown.enter)="setLanguage('fr')"
                  >
                      <qtm-menu-item-label>FR - Français</qtm-menu-item-label>
                  </qtm-menu-item>
              }
              @if (isLangVisible(LangEnum.EN)) {
                  <qtm-menu-item
                          (click)="setLanguage('en')"
                          (keydown.enter)="setLanguage('en')"
                  >
                      <qtm-menu-item-label>ENG - English</qtm-menu-item-label>
                  </qtm-menu-item>
              }
              @if (isLangVisible(LangEnum.RO)) {
                  <qtm-menu-item
                          (click)="setLanguage('ro')"
                          (keydown.enter)="setLanguage('ro')"
                  >
                      <qtm-menu-item-label>RO - Română</qtm-menu-item-label>
                  </qtm-menu-item>
              }
          </qtm-menu-item-list>
        </qtm-dropdown-overlay>
      </qtm-dropdown>
      @if (user$ | async; as user) {
        <qtm-dropdown
          placement="bottom-right"
          [visible]="dropdownIsToggled"
          (visibleChange)="toggleDropdown($event)"
        >
          <qtm-dropdown-trigger>
            <qtm-button classes="bg-black-100 border border-bluegrey-400">
              <qtm-icon icon="person"></qtm-icon>
              <qtm-typography classes="pr-xl pl-none"
                >{{ user.name | titlecase }}
                {{ user.surname | uppercase }}</qtm-typography
              >
              @if (!dropdownIsToggled) {
                <qtm-icon icon="keyboard_arrow_down"></qtm-icon>
              } @else {
                <qtm-icon icon="keyboard_arrow_up"></qtm-icon>
              }
            </qtm-button>
          </qtm-dropdown-trigger>
          <qtm-dropdown-overlay>
            <qtm-menu-item-list (clickItem)="profileClicked()">
              <qtm-menu-item>
                <qtm-menu-item-label
                  routerLink="/userProfile"
                  routerLinkActive="active"
                >
                  <qtm-icon icon="person"></qtm-icon>
                  <qtm-typography>{{
                    "header.profile" | translate
                  }}</qtm-typography>
                </qtm-menu-item-label>
              </qtm-menu-item>
              <qtm-menu-item (click)="logout()">
                <qtm-menu-item-label>
                  <qtm-icon icon="logout"></qtm-icon>
                  <qtm-typography>{{
                    "header.logout" | translate
                  }}</qtm-typography>
                </qtm-menu-item-label>
              </qtm-menu-item>
            </qtm-menu-item-list>
          </qtm-dropdown-overlay>
        </qtm-dropdown>
      }
    </qtm-header-menu-right>
  </qtm-header-menu>
  <div class="phone-menu mt-1">
    <div class="d-flex flex-row">
      <qtm-button
        variant="ghost"
        color="neutral"
        classes="ml-s"
        (click)="toggleLang()"
      >
        <qtm-icon icon="translate"></qtm-icon>
      </qtm-button>
      <qtm-button
        variant="ghost"
        color="neutral"
        classes="ml-s"
        class="mt-none"
        (click)="toggleButton()"
      >
        <qtm-icon icon="{{ menuIsVisible ? 'close' : 'menu' }}"></qtm-icon>
      </qtm-button>
    </div>
  </div>
</qtm-header>
